import React from "react";
import { Outlet } from "react-router-dom";

import { UmpiresProvider } from "../contexts/Umpires";

import { store } from "../../../..";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import {
    globalActions,
    selectUmpires,
} from "../../../../features/global/globalSlice";

export const loader = async () => {
    const { settings, sites, umpires } = store.getState().global;
    const promises = [];
    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !sites.length && promises.push(store.dispatch(globalActions.getSites()));
    !umpires.length &&
        promises.push(store.dispatch(globalActions.getUmpires()));

    await Promise.all([promises]);

    return null;
};

const UmpiresLayout = (): React.JSX.Element => {
    const umpires = useAppSelector(selectUmpires);

    return (
        <UmpiresProvider initialUmpires={umpires}>
            <Outlet />
        </UmpiresProvider>
    );
};

export default UmpiresLayout;
